// network-log.interceptor.ts
import { inject, Injectable } from '@angular/core';
import { ErrorAggregatorService } from '@root/app/error-aggregation/error-aggregator.service';
import { Observable, tap } from 'rxjs';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { environment } from '@root/environments/environment';

@Injectable()
export class NetworkLogInterceptor implements HttpInterceptor {
  private readonly errorAggregatorService = inject(ErrorAggregatorService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const requestStartTime = Date.now();

    return next.handle(req).pipe(
      tap({
        next: (event) => {
          if (
            event instanceof HttpResponse &&
            event.url?.includes(environment.apiUrl)
          ) {
            this.errorAggregatorService.captureNetworkLog({
              method: req.method,
              url: req.url,
              status: event.status,
              requestDuration: Date.now() - requestStartTime,
              requestStartTime,
              requestHeaders: req.headers,
              responseHeaders: event.headers,
              requestBody: req.body,
              responseBody: event.body,
            });
          }
        },
        error: (e: unknown) => {
          const errorRes = e as HttpErrorResponse;
          this.errorAggregatorService.captureNetworkLog({
            method: req.method,
            url: req.url,
            status: errorRes.status ?? 0,
            requestDuration: Date.now() - requestStartTime,
            requestStartTime,
            error: errorRes.message,
            requestHeaders: req.headers,
            requestBody: req.body,
            responseBody: errorRes?.error,
          });
        },
      })
    );
  }
}
